import PropTypes from 'prop-types';

import { OrderItemPropTypes } from './OrderItem.proptypes';

export const OrderDefaultProps = {
  id: null,
  order_lines: [],
  status: {},
};

export const OrderPropTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  order_lines: PropTypes.arrayOf(
    PropTypes.shape({
      ...OrderItemPropTypes,
    }),
  ),
  status: PropTypes.shape({
    code: PropTypes.string,
    label: PropTypes.string,
  }),
};
